import script from "./ClausulasComerciaisAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./ClausulasComerciaisAdministrar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__